<div class="card-container">
  <form #form="ngForm" class="parcelamento-form">
    <mat-card-title>Parcelamento</mat-card-title>

    <mat-card-subtitle>
      Caso necessário altere o Valor de Entrada e a Data de Vencimento.
    </mat-card-subtitle>
    <mat-form-field class="form-field" appearance="outline">
      <mat-label>Valor de Entrada</mat-label>
      <input
        matInput
        name="inputEntrada"
        id="inputEntrada"
        #inputEntrada="ngModel"
        (ngModelChange)="(!inputEntrada.invalid && !inputDataVencimento.invalid) && selectPlanoModelChanged.next()"
        [(ngModel)]="customizacaoParcelamento.valorEntrada"
        currencyMask
        required
        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
        [min]="valorMinimoEntrada"
        [max]="valorMaximoEntrada"
      >
      <mat-error class="mat-error" *ngIf="inputEntrada?.errors?.max">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Entrada máxima {{valorMaximoEntrada | currency:'BRL'}}
      </mat-error>
      <mat-error class="mat-error" *ngIf="inputEntrada?.errors?.min">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Entrada mínima {{valorMinimoEntrada | currency:'BRL'}}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="form-field" appearance="outline">
      <mat-label>Data de Vencimento</mat-label>

      <input
        matInput
        name="inputDataVencimento"
        #inputDataVencimento="ngModel"
        (ngModelChange)="(!inputDataVencimento.invalid && !inputEntrada.invalid) && selectPlanoModelChanged.next()"
        [(ngModel)]="customizacaoParcelamento.dataVencimento"
        [matDatepicker]="picker"
        [min]="dataMinimaEntrada"
        [max]="dataMaximaEntrada"
        (click)="!inputEntrada.invalid && datepickerToggle.datepicker.open()"
        readonly
        required
        placeholder="Data de vencimento da entrada"
      >
      <mat-error *ngIf="inputDataVencimento?.errors?.matDatepickerMax">
        Data máxima permitida {{ dataMaximaEntrada | date:'dd/MM/yyyy' }}
      </mat-error>

      <mat-error *ngIf="inputDataVencimento?.errors?.matDatepickerMin">
        Data mínima permitida {{ dataMinimaEntrada | date:'dd/MM/yyyy' }}
      </mat-error>

      <mat-datepicker-toggle #datepickerToggle matSuffix [disabled]="inputEntrada.invalid" [for]="picker"></mat-datepicker-toggle>

      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field plano-field">
      <mat-label>Plano</mat-label>
      <mat-select required [(ngModel)]="planoSelecioando" #selectPlano name="selectPlano"  >
        <mat-option
          *ngFor="let plano of planos"
          [value]="plano">
          {{ getSelectPlanoLabel(plano) }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="planoSelecioando === null || planoSelecioando === undefined">
        Plano é um campo obrigatório
      </mat-error>
    </mat-form-field>

    <button
      mat-raised-button
      [disabled]="form.invalid" 
      (click)="emitSelecionarPlano(planoSelecioando)"
      color="primary">
      Escolher Plano
    </button>
  </form>
</div>